import {useIntl} from 'react-intl'
import {Link} from 'react-router-dom'
import clsx from 'clsx'
import {ROUTES} from '../../../../../_gori/constants'
import {useAuth} from '../../../auth'
import {toAbsoluteUrl} from '../../../../../_gori/helpers'
import type {ManifestStatus} from '../../utils/verifyUtils'
import {STATUS_CONFIG, STATUS_ICON, STATUS_MESSAGE_KEY} from '../../utils/verifyUtils'

interface StatusAlertProps {
  status: ManifestStatus
  isManual?: boolean
}

export function StatusAlert({status, isManual = false}: StatusAlertProps) {
  const intl = useIntl()
  const {currentUser} = useAuth()
  const statusConfig = STATUS_CONFIG[status]
  const icon = STATUS_ICON[status]

  // For manual entry, only show alert for actionable statuses
  if (isManual && status !== 'fraud' && status !== 'invalid' && status !== 'expired') return null

  return (
    <div className='gori-signature-status-section'>
      <div
        className={clsx(`alert alert-${statusConfig.color} gori-signature-status-alert`, {
          'padding-invalid': status === 'invalid',
          'alert-expired': status === 'expired',
          'alert-paid': status === 'paid',
        })}
        role='alert'
      >
        <h4 className='alert-heading mb-2'>
          {intl.formatMessage({id: `GORI_SIGNATURE_MANIFEST_TYPE`})}:{' '}
          {intl.formatMessage({id: statusConfig.titleKey})}
          {icon && (
            <img
              src={toAbsoluteUrl(icon)}
              alt=''
              aria-hidden='true'
              className='gori-signature-status-icon'
            />
          )}
        </h4>
        {STATUS_MESSAGE_KEY[status] && (
          <p className='mb-0'>{intl.formatMessage({id: STATUS_MESSAGE_KEY[status]!})}</p>
        )}
      </div>

      {status === 'pending' && (
        <p className='gori-signature-manifest-text'>
          {intl.formatMessage({id: 'GORI_SIGNATURE_MANIFEST_INSTRUCTION'})}{' '}
          <Link
            to={currentUser ? ROUTES.END_OF_DAY.OPEN_SHIPMENTS : ROUTES.AUTH.LOGIN}
            className='gori-signature-manifest-link'
          >
            {intl.formatMessage({id: 'GORI_SIGNATURE_MANIFEST_LINK'})}
          </Link>
        </p>
      )}

      {(status === 'fraud' || status === 'invalid') && (
        <p className='gori-signature-manifest-text'>
          {intl.formatMessage(
            {id: 'GORI_SIGNATURE_FRAUD_INSTRUCTION'},
            {
              uspsLink: (
                <a
                  href='https://www.uspis.gov/report'
                  target='_blank'
                  rel='noopener noreferrer'
                  className='gori-signature-manifest-link'
                >
                  {intl.formatMessage({id: 'GORI_SIGNATURE_FRAUD_LINK'})}
                </a>
              ),
            }
          )}
        </p>
      )}
    </div>
  )
}
StatusAlert.displayName = 'StatusAlert'
